/* libs */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

/* components */
import NavItem from "./NavItem";

const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

const SideBarSection = props => {
	const {
		title,
		to,
		items,
		itemPath,
		itemSuffix,
		children,
		gridPath,
		activeId,
		deleteItem,
		showOptions,
		showCaret,
	} = props;

	const linkTitle = title ? capitalize(title) : "";
	return (
		<div className="sidebar-section">
			{to && (
				<Link to={to} className="sidebar-add" title={`Add A ${linkTitle}`}>
					<i className="fal fa-plus"></i>
				</Link>
			)}
			{showCaret && (
				<div className="sidebar-caret">
					<i className="fal fa-angle-right"></i>
				</div>
			)}
			{gridPath ? (
				<Link to={gridPath}>
					<div className="sidebar-section-title">{title}</div>
				</Link>
			) : (
				<div className="sidebar-section-title">{title}</div>
			)}
			{items && (
				<div>
					{items.length > 0 ? (
						items.map(item => (
							<NavItem
								key={item.id}
								id={item.id}
								linkTo={`${itemPath}/${item.id}${itemSuffix ? itemSuffix : ""}`}
								copyTo={`${itemPath}/copy/${item.id}`}
								text={item.name}
								isActive={activeId && item.id === activeId}
								showOptions={showOptions === false ? false : true}
								deleteItem={deleteItem}
							/>
						))
					) : (
						<div className="ta-center note-with-icon">
							<i className="fal fa-sad-tear"></i>
							<div>No {linkTitle}</div>
						</div>
					)}
				</div>
			)}
			{items && <div className="sidebar-bottom-border"></div>}
			{children}
			{children && <div className="sidebar-bottom-border"></div>}
		</div>
	);
};

SideBarSection.propTypes = {
	activeId: PropTypes.string,
	children: PropTypes.any,
	deleteItem: PropTypes.func,
	gridPath: PropTypes.string,
	itemPath: PropTypes.string,
	items: PropTypes.array,
	itemSuffix: PropTypes.string,
	showOptions: PropTypes.bool,
	title: PropTypes.string,
	to: PropTypes.string,
};

export default SideBarSection;
